import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'separator', 'Separator', [["path",{"d":"M3 12l0 .01"}],["path",{"d":"M7 12l10 0"}],["path",{"d":"M21 12l0 .01"}]]);